import { Injectable } from '@angular/core';
import { SupabaseDatabaseService } from './supabase-database.service';
import TYPES from '../constants/types';

@Injectable({
  providedIn: 'root',
})
export class GoogleAccountService<GoogleAccount> extends SupabaseDatabaseService<GoogleAccount> {

  async isGoogleCalendarConnected(): Promise<boolean> {
    const { data, error } = await this.supabase
      .from(TYPES.DATABASE.TABLES.GOOGLE_ACCOUNTS)
      .select('id')
      .maybeSingle();

    if (error) {
      console.error(error);
      return false;
    }

    return Boolean(data);
  }
  
}
